import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { AlertTriangle, ShieldAlert, Loader2 } from 'lucide-react';
import { fmtMeetingDate, fmtMeetingTime } from '../../lib/meetings';

/** Shown when the server blocks a double-booking (409). Managers/Admins may
 * override with a mandatory reason — the override is fully audited. */
export const ConflictWarning = ({ conflict, canOverride, overrideReason, setOverrideReason, onOverride, saving }) => (
  <div className="rounded-lg border border-orange-300 bg-orange-50 p-3 space-y-2" data-testid="meeting-conflict-warning">
    <div className="flex items-start gap-2 text-orange-800">
      <AlertTriangle size={15} className="mt-0.5 shrink-0" />
      <div className="text-xs font-medium">{conflict.message}</div>
    </div>
    <div className="space-y-1">
      {(conflict.conflicts || []).slice(0, 3).map((c) => (
        <div key={c.id} className="text-[11px] text-orange-700 pl-6">
          • {c.title} — {fmtMeetingDate(c.start_at)}, {fmtMeetingTime(c.start_at)}–{fmtMeetingTime(c.end_at)}
        </div>
      ))}
    </div>
    {canOverride ? (
      <div className="flex gap-2 pt-1">
        <Input value={overrideReason} onChange={(e) => setOverrideReason(e.target.value)}
          placeholder="Override reason (required, audited)" className="h-8 text-xs bg-white"
          data-testid="meeting-override-reason-input" />
        <Button size="sm" variant="outline" className="h-8 border-orange-400 text-orange-800 hover:bg-orange-100"
          disabled={!overrideReason.trim() || saving} onClick={onOverride} data-testid="meeting-override-btn">
          {saving ? <Loader2 size={12} className="animate-spin mr-1" /> : <ShieldAlert size={12} className="mr-1" />}
          Override & Book
        </Button>
      </div>
    ) : (
      <div className="text-[11px] text-orange-700 pl-6">Pick another slot — only a Manager/Admin can override conflicts.</div>
    )}
  </div>
);
